<!--
  - Copyright (c) Interactive Information R & D (I2RD) LLC.
  - All Rights Reserved.
  -
  - This software is confidential and proprietary information of
  - I2RD LLC ("Confidential Information"). You shall not disclose
  - such Confidential Information and shall use it only in
  - accordance with the terms of the license agreement you entered
  - into with I2RD.
  -->

<template>
  <BarChart id="nvo-aging-report" :options="chartOptions" :data="chartData" />
</template>

<script>
import BarChart from "@/components/BarChart";
import pdsVars from "@/pds/styles/pds-js-variables.scss";

export default {
  name: "NvoAgingReport",
  components: { BarChart },
  props: ["aging-data"],
  data() {
    return {
      chartOptions: chartOptions
    };
  },
  computed: {
    chartData() {
      if (this.agingData == null) return {};

      let chartData = [
        {
          label: "<2 Days",
          data: this.agingData
            .filter(ad => ad.age === 0)
            .sort((a, b) => a.stage - b.stage)
            .map(ad => ad.count),
          backgroundColor: pdsVars.colorAlertGreen,
          maxBarThickness: 70
        },
        {
          label: "2-7 Days",
          data: this.agingData
            .filter(ad => ad.age === 1)
            .sort((a, b) => a.stage - b.stage)
            .map(ad => ad.count),
          backgroundColor: pdsVars.colorSemanticStateYellow300,
          maxBarThickness: 70
        },
        {
          label: "7-14 Days",
          data: this.agingData
            .filter(ad => ad.age === 2)
            .sort((a, b) => a.stage - b.stage)
            .map(ad => ad.count),
          backgroundColor: pdsVars.colorAlertOrange,
          maxBarThickness: 70
        },
        {
          label: "> 14 Days",
          data: this.agingData
            .filter(ad => ad.age === 3)
            .sort((a, b) => a.stage - b.stage)
            .map(ad => ad.count),
          backgroundColor: pdsVars.colorSemanticStateRed600,
          maxBarThickness: 70
        }
      ];

      return {
        labels: chartLabels,
        datasets: chartData
      };
    }
  }
};

const chartOptions = {
  responsive: true,
  maintainAspectRatio: false,
  legend: { position: "right", labels: { boxWidth: 12 } },
  scales: {
    xAxes: [
      {
        scaleLabel: {
          display: true,
          fontStyle: "bold",
          labelString: "Stage Status"
        },
        stacked: true,
        gridLines: { display: false }
      }
    ],
    yAxes: [
      {
        scaleLabel: {
          display: true,
          fontStyle: "bold",
          labelString: "Vendors"
        },
        stacked: true
      }
    ]
  }
};

const chartLabels = [
  "Not Enrolled",
  "Pending Review",
  "Revision Requested",
  "Pending Export"
];
</script>
